<div class="content">
  <div class="content__close" (click)="onNoClick()">
    <img src="../../../assets/img/icons/close-white-bg.png">
  </div>
  <div class="content__container">
    <h3 class="content__container__title color_gh">{{data.header}}</h3>
    @if (data.logo && (data.logo !== '')) {
      <div class="content__container__image"><img [src]="blobStorage + data.logo"></div>
    }
    <p class="content__container__tag">{{data.text}}</p>
  </div>
  <div class="content__btn">
    @for (item of data.navigationButtons; track item) {
      <div>
        <button  class="content__btn__{{item.btnClass}} background_border_gh" (click)="navigateTo(item.btnURL, item.btnText, item.navigateToExSite)">{{item.btnText}}</button>
      </div>
    }
  </div>
</div>
